<template>
	<div id="interview_member">
        <HrrBreadcrumb PMname="其他功能" CMname="广告信息管理" C2Mname="绑定设备" />
        <div id="adData" :model="adform" >
                    <span>广告ID：</span>
                    {{adform.adId}}，
                    <span>广告标题：</span>
                    {{adform.adTitle}}，
                    <span>广告类型：</span>
                    {{adform.adType}}
        </div>
        <br />
        <HrrMainLayout :nobuttons="false" >
            <template slot="searh">
                <el-form :inline="true" :model="mform">
                   <el-form-item label="站点名称：">
						<el-select v-model="mform.siteId" @change="mChangeSiteId" placeholder="请选择" filterable >
							<el-option 
							label="全部" 
							value=""></el-option>
							<el-option v-for="item in siteidData" 
							:key="item.SiteId"
							:label="item.SiteName" 
							:value="item.SiteId">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="媒体名称：">
						<el-select v-model="mform.lightBoxId"  placeholder="请选择" filterable >
							<el-option 
							label="全部" 
							value=""></el-option>
							<el-option v-for="item in mAdLightBox" 
							:key="item.lightBoxId +'-'+item.deviceId"
							:label="item.lightBoxName" 
							:value="item.lightBoxId">
							</el-option>
						</el-select>
					</el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询</el-button>
                        <el-button type="info" icon="el-icon-back" @click="returnForm" >返回</el-button>
                    </el-form-item>
                </el-form>
            </template>
            <template slot="buttons">
                <el-button-group>
                    <el-button type="primary" icon="fa fa-cubes" size="small" @click="addCardAllclick()" :disabled="checkAdType">批量绑定卡片</el-button>
                </el-button-group>
            </template>
            <template slot="table">
                <el-table :data="membertable" ref="membertable"
                border 
                stripe 
                highlight-current-row 
                v-loading="mloading"
                style="width: 100%; margin-top: 20px;" >
                    <el-table-column prop="deviceId" label="设备ID" width="140" fixed="left">
                    </el-table-column>
                    <el-table-column prop="deviceNickCode" label="设备编号" width="180" fixed="left">
                    </el-table-column>
                    <el-table-column prop="deviceCode" label="自动设备编号" width="120" v-if="isHadFun('deviceCode')">
                    </el-table-column>
                    <el-table-column prop="deviceName" label="设备名称"  fixed="left">
                    </el-table-column>
                    <el-table-column prop="cardCode" label="卡片编号" width="180" fixed="left">
                    </el-table-column>
                    <el-table-column prop="lightBoxCode" label="所在媒体编号" >
                    </el-table-column>
                    <el-table-column prop="siteName" label="所属站点" >
                    </el-table-column>
                    <el-table-column label="操作" width="200" fixed="right">
                        <template slot-scope="scope">
                            <el-button @click.stop="DeleteDevice(scope.row)" type="text" size="small">返回待绑定</el-button>
                            <el-button @click.stop="BindcardData(scope.row)" type="text" size="small" v-if="checkAdType">绑定卡片</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
            <template slot="Pagination">
                <el-pagination background @size-change="mhandleSizeChange" @current-change="mhandleCurrentChange" :current-page="mform.pageNum" :page-sizes="[5, 10, 15]" layout="total, sizes, prev, pager, next, jumper" :total="mtotal">
                </el-pagination>
            </template>
        </HrrMainLayout>
        <h3>待绑定设备</h3>
        <HrrMainLayout >
            <template slot="searh">
                <el-form :inline="true" :model="uform">
                    <el-form-item label="站点名称：">
						<el-select v-model="uform.siteId" @change="changeSiteId" placeholder="请选择" filterable >
							<el-option 
							label="全部" 
							value=""></el-option>
							<el-option v-for="item in siteidData" 
							:key="item.SiteId"
							:label="item.SiteName" 
							:value="item.SiteId">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="媒体名称：">
						<el-select v-model="uform.lightBoxId"  placeholder="请选择" filterable >
							<el-option 
							label="全部" 
							value=""></el-option>
							<el-option v-for="item in adLightBox" 
							:key="item.lightBoxId +'-'+item.deviceId"
							:label="item.lightBoxName" 
							:value="item.lightBoxId">
							</el-option>
						</el-select>
					</el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onuSubmit">查 询</el-button>
                    </el-form-item>
                </el-form>
            </template>
            <template slot="buttons">
                <el-button-group>
                    <el-button type="primary" icon="fa fa-cubes" size="small" @click="addDeviceAllclick()">批量绑定设备</el-button>
                </el-button-group>
            </template>
            <template slot="table">
                <el-table :data="uData" ref="utable"
                border 
                stripe 
                highlight-current-row 
                v-loading="uloading"
                style="width: 100%" @cell-click="cellclick" @selection-change="selectionchange">
                    <el-table-column type="selection" width="55" fixed="left">
                    </el-table-column>
                    <el-table-column prop="deviceId" label="设备ID" width="140" fixed="left">
                    </el-table-column>
                    <el-table-column prop="deviceNickCode" label="设备编号" width="180" fixed="left">
                    </el-table-column>
                    <el-table-column prop="deviceCode" label="自动设备编号" width="120" v-if="isHadFun('deviceCode')">
                    </el-table-column>
                    <el-table-column prop="deviceName" label="设备名称" width="180" fixed="left">
                    </el-table-column>
                    <el-table-column prop="lightBoxCode" label="所在媒体编号" >
                    </el-table-column>
                    <el-table-column prop="siteName" label="所属站点" >
                    </el-table-column>
                    <el-table-column label="操作" width="100" fixed="right">
                        <template slot-scope="scope">
                            <el-button @click.stop="BindingDevice(scope.row)" type="text" size="small">绑定设备</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
            <template slot="Pagination">
                <el-pagination background @size-change="uhandleSizeChange" @current-change="uhandleCurrentChange" :current-page="uform.pageNum" :page-sizes="[5, 10, 15]" layout="total, sizes, prev, pager, next, jumper" :total="utotal">
                </el-pagination>
            </template>
        </HrrMainLayout>
        <el-dialog title="绑定卡片"  v-model="dialogVisible" :visible.sync="dialogVisible" :before-close="handleClose" class="el-dialog-resume">
            <el-tabs type="card" >
                <el-card class="educard" >
                    <template>
                        <el-form class="eduform" label-width="130px" >
                            <el-form-item label="卡号：" >
                                <el-autocomplete
                                class="inline-input"
                                v-model="state"
                                :fetch-suggestions="querySearch"
                                placeholder="请输入内容"
                                :trigger-on-focus="true"
                                @select="handleSelect"
                                ></el-autocomplete>
                            </el-form-item>
                            <el-form-item label=" ">
                                <el-button type="primary" @click="BindingCard()" >确定</el-button>
                            </el-form-item>
                        </el-form>
                    </template>
                </el-card>
            </el-tabs>
    </el-dialog>
    <el-dialog title="批量绑定卡片"  v-model="cardDialogVisible" :visible.sync="cardDialogVisible" :before-close="cardHandleClose" class="el-dialog-resume">
            <el-tabs type="card" >
                <el-card class="educard" >
                    <template>
                        <el-form class="eduform" label-width="130px" >
                            <el-form-item label="卡号：" >
                                <el-autocomplete
                                class="inline-input"
                                v-model="cardFront"
                                :fetch-suggestions="querySearch"
                                placeholder="请输入内容"
                                :trigger-on-focus="true"
                                @focus="FrontInputFocus"
                                @select="handleSelect"
                                ></el-autocomplete>
                                <span>--至--</span>
                                <el-autocomplete
                                class="inline-input"
                                v-model="cardBehind"
                                :fetch-suggestions="querySearch"
                                placeholder="请输入内容"
                                :trigger-on-focus="true"
                                @focus="onInputFocus"
                                @select="handleSelect"
                                ></el-autocomplete>
                            </el-form-item>
                            <el-form-item label=" ">
                                <el-button type="primary" @click="BatchBindingCard()" >确定</el-button>
                            </el-form-item>
                        </el-form>
                    </template>
                </el-card>
            </el-tabs>
    </el-dialog>
	</div>
</template>
<script>
    export default {
        name: 'AD_Bindcard',
        data() {
            return {
                mform: {
                    pageNum: 1,
                    pageSize: 10,
                    adId:this.$route.params.id,
                    deviceId:"",
                    deviceCode:"",
                    deviceName:"",
                    deviceNickCode:"",
                    lightBoxCode:"",
                    siteName:"",
                    siteId:"",
                    lightBoxId:"",
                },
                uform: {
                    pageNum: 1,
                    pageSize: 10,
                    adId:this.$route.params.id,
                    deviceId:"",
                    deviceCode:"",
                    deviceName:"",
                    deviceNickCode:"",
                    lightBoxCode:"",
                    siteName:"",
                    siteId:"",
                    lightBoxId:"",
                },
                adform: {
                adId:this.$route.meta.row.adId,
                adTitle:this.$route.meta.row.adTitle,
                adType:this.$route.meta.row.adType
                },
                siteidData:[],
                mAdLightBox:[],
                adLightBox:[],
                adLightBoxDefault:0,
                mAdLightBoxDefault:0,
                dialogVisible:false,
                cardDialogVisible:false,
                BindCardAdid:"",
                state:"",
                cardFront:"",
                cardBehind:"",
                deviceId:"",
                checkAdType:false,


                membertable:[],
                uData:[],
                mtotal: 0,
                utotal: 0,
                mloading: false,
                uloading: false,
                selectionRows:[],
                cardselectionRows:[],
                showInterviewDesc:"",
            }
        },
        methods: {
            onSubmit() {
                this.initData();
            },
            onuSubmit(){
                this.initunselectData();
            },
            returnForm(){
                this.$router.go(-1);
            },
            mhandleSizeChange(val) {
				this.mform.pageSize=val;
				this.initData();
			},
			mhandleCurrentChange(val) {
				this.mform.pageNum=val;
				this.initData();
			},
            uhandleSizeChange(val) {
                this.uform.pageSize=val;
                this.initunselectData();
            },
            uhandleCurrentChange(val) {
                this.uform.pageNum=val;
                this.initunselectData();
            },
            BindingDevice(val){
				this.$confirm("确定要绑定  设备号：'"+val.deviceNickCode+"',设备名称：'"+val.deviceName+"' 此记录么？","绑定提示",{type:"warning"})
				.then(()=>{
                    var Vuethis=this;
                    this.$hrraxios.post(this.$api.Bindcard.addevice,{adId:this.$route.params.id,deviceId:val.deviceId})
					.then((response)=>{
						var redata=response.data;
						if(redata.Success==true){
							Vuethis.$message({message:"绑定成功！",type:"success"});
                            Vuethis.initData();
                            Vuethis.initunselectData();
						}else{
							Vuethis.$message({message:redata.Prompt,type:"error"});
						}
					})
				}).catch((error)=>{
					console.log(error);
				});
            },
            DeleteDevice(val){
                console.log(val)
                this.$confirm("确定要将 设备号：'"+val.deviceNickCode+"',设备名称：'"+val.deviceName+"' 移出绑定么？","返回待绑定提示",{type:"warning"})
                .then(()=>{
                    var loading = this.$loading({
                        lock: true,
                        text: '处理中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    var Vthis=this;
                    this.$hrraxios({
                        method: "delete",
                        url:this.$api.Bindcard.addevice+"/"+val.addId})
                    .then((response)=>{
                        loading.close();
                        var redata=response.data;
                        if(redata.Success==true){
                            Vthis.$alert("移除成功！",{callback:action=>{
                                Vthis.initData();
                                Vthis.initunselectData();
                            }});
                        }else{
                            Vthis.$message({message:redata.Prompt,type:"error"});
                        }
                    })
                    .catch((error)=>{
                        loading.close();
                        console.log(error);
                    });
                })
                .catch((error)=>{
                    console.log(error);
                });
            },
            cellclick(row, column, cell, event){
                this.$refs.utable.toggleRowSelection(row);
            },
            selectionchange(selection){
                this.selectionRows=selection;
            },
            addDeviceAllclick(){
                if(this.selectionRows.length<1)
                {
                    this.$message({message:"请先选择一行在绑定",type:"warning"});
                    return;
                }
                this.$confirm("确定要绑定这些记录么？",{type:"warning"})
				.then(()=>{
					var loading = this.$loading({
						lock: true,
						text: '绑定中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					var Vuethis=this;
					var PostfunArr=[];
					this.selectionRows.forEach(myrow=>{
                       var postRe=this.$hrraxios.post(this.$api.Bindcard.addevice,{adId:this.$route.params.id,deviceId:myrow.deviceId})
						// var postRe=this.$hrraxios({
                        // method: "post",
                        // url:this.$api.AD.DelAD+"/"+myrow.adId})
						PostfunArr.push(postRe);
					});
					this.$axios.all(PostfunArr)
					.then(this.$axios.spread(function(){
						loading.close();
						//console.log(arguments);
						var isalldel=true;
						for(var i=0;i<arguments.length;i++){
							if(arguments[i].data.Success==false)
							{
								isalldel=false;
							}
						}
						if(isalldel==true){
							Vuethis.$message({message:"全部绑定成功！",type:"success"});
                            Vuethis.initData();
                            Vuethis.initunselectData();
						}else{
							//有删除失败的未处理
						}
					}));
				})
				.catch((error)=>{
					
				});
            },
            querySearch(queryString, cb) {
			//this.loadAll(queryString);
			var Vuethis=this;
			this.$hrraxios.get(this.$api.card.getSearch+queryString)
			.then(function (response) {
				var data=response.data;
				if(data.Success==true)
				{
					Vuethis.restaurants=data.Data;
					cb(Vuethis.restaurants);
				}else{
					Vuethis.$message.error(data.Prompt);
				}
			})
			.catch(function (error) {
				console.log(error);
			});
			// cb([{value:'text'}]);
        },
        handleSelect(item) {
			//console.log(item);
        },
        cardHandleClose(done) { 
            this.cardFront="";
            this.cardBehind="";
			done();
        },
        addCardAllclick(){
             //console.log(this.cardselectionRows)
				this.cardDialogVisible=true;
            },
            onInputFocus(){
                if(this.cardBehind==""){
                    if(this.cardFront!=""){
                        this.cardBehind=this.cardFront.substring(0, 10)
                    }
                }
            },
            FrontInputFocus(){
                if(this.cardFront==""){
                    if(this.cardBehind!=""){
                        this.cardFront=this.cardBehind.substring(0, 10)
                    }
                }
            },
            BatchBindingCard(){
                var startCode=this.cardFront;
                var endCode=this.cardBehind
				if(startCode==""||endCode=="")
				{
					this.$message({message:"请先输入卡号",type:"warning"});
					return;
                }
                if(startCode.length<16||endCode.length<16){
                    this.$message({message:"请先输入完整卡号",type:"warning"});
					return;
                }
                if(startCode.length>16||endCode.length>16){
                    this.$message({message:"请先输入正确卡号",type:"warning"});
					return;
                }
                if(startCode.substring(0, 10)!=endCode.substring(0, 10)){
                    this.$message({message:"请输入相同卡号批次",type:"warning"});
					return;
                }
                var Vuethis=this;
				this.$hrraxios.post(this.$api.Bindcard.cardcodebatch,{adId:this.$route.params.id,startCode:startCode,endCode:endCode})
                .then((response)=>{
                    var redata=response.data;
                    if(redata.Success==true){
                        Vuethis.$message({message:"绑定成功！",type:"success"});
                        Vuethis.cardFront=""
                        Vuethis.cardBehind=""
                        Vuethis.cardDialogVisible=false;
                        this.initData();
                        this.initParamsData();
                    }else{
                        Vuethis.$message({message:redata.Prompt,type:"error"});
                    }
                })
			},
            handleClose(done) {
			this.state=""
			done();
		},
            BindcardData(val){
                if(val.cardCode!=null){
                    this.$message({message:"该设备已绑定过卡片！",type:"error"});
                    return
                }
                this.BindCardAdid=val.addId
                this.deviceId=val.deviceId
				this.dialogVisible=true;
			},
            BindingCard(){
			var Vuethis=this;
			this.$hrraxios.post(this.$api.Bindcard.cardcode,{adId:this.$route.params.id,addId:this.BindCardAdid,deviceId:this.BindCardAdid,cardCode:this.state})
			.then((response)=>{
				var redata=response.data;
				if(redata.Success==true){
					Vuethis.$message({message:"绑定成功！",type:"success"});
					Vuethis.state=""
					Vuethis.dialogVisible=false;
				}else{
					Vuethis.$message({message:redata.Prompt,type:"error"});
				}
			})
	  	},
            changeSiteId(val){
				if(val==""){
					this.adLightBoxDefault=0
				}else{
					this.adLightBoxDefault=val
				}
                this.uform.lightBoxId="";
				this.adLightBoxData();
            },
            mChangeSiteId(val){
				if(val==""){
					this.mAdLightBoxDefault=0
				}else{
					this.mAdLightBoxDefault=val
				}
                this.mform.lightBoxId="";
				this.mAdLightBoxData();
            },
            initData() {
                var Vuethis = this;
                this.mloading = true;
                this.$hrraxios.get(this.$api.Bindcard.selected, {params: this.mform})
                .then(function(response) {
                    Vuethis.mloading = false;
                    var data = response.data;
                    if (data.Success == true) {
                        Vuethis.membertable = data.Data.List;
                        Vuethis.mtotal = data.Data.Total;
                        var adData=Vuethis.$route.meta.row;
                        if(adData.adType=="组校验"){
                             for(var i=0;i<Vuethis.membertable.length;i++){
                                 if(Vuethis.membertable[i].cardCode!=null){
                                     Vuethis.checkAdType=true
                                 }
                             }
                            }
                    } else {
                        Vuethis.$message.error(data.prompt);
                    }
                })
                .catch(function(error) {
                    Vuethis.mloading = false;
                    console.log(error);
                });
            },
            initunselectData(){
                var Vuethis = this;
                this.uloading = true;
                this.$hrraxios.get(this.$api.Bindcard.unselected, {params: this.uform})
                .then(function(response) {
                    Vuethis.uloading = false;
                    var data = response.data;
                    if (data.Success == true) {
                        Vuethis.uData = data.Data.List;
                        Vuethis.utotal = data.Data.Total;
                    } else {
                        Vuethis.$message.error(data.prompt);
                    }
                })
                .catch(function(error) {
                    Vuethis.uloading = false;
                    console.log(error);
                });
            },
            initParamsData(){
				var Vuethis=this;
				this.$hrraxios.get(this.$api.site.downlist)
				.then(function (response) {
					var data=response.data;
					if(data.Success==true)
					{
						Vuethis.siteidData=data.Data;
					}else{
						Vuethis.$message.error(data.Prompt);
					}
				})
				.catch(function (error) {
					console.log(error);
				});
            },
            adLightBoxData(){
				var Vuethis=this;
				this.$hrraxios.get(this.$api.device.getNoDevice+"/"+this.adLightBoxDefault)
				.then(function (response) {
					var data=response.data;
					if(data.Success==true)
					{
						Vuethis.adLightBox=data.Data;
					}else{
						Vuethis.$message.error(data.Prompt);
					}
				})
				.catch(function (error) {
					console.log(error);
				});
			},
            mAdLightBoxData(){
				var Vuethis=this;
				this.$hrraxios.get(this.$api.device.getNoDevice+"/"+this.mAdLightBoxDefault)
				.then(function (response) {
					var data=response.data;
					if(data.Success==true)
					{
						Vuethis.mAdLightBox=data.Data;
					}else{
						Vuethis.$message.error(data.Prompt);
					}
				})
				.catch(function (error) {
					console.log(error);
				});
			},
        },
        created() {
            if(this.$route.meta.row.adType=="单校验"){
                this.checkAdType=true      
            }
            this.$common.getFunListByMCode(this,"ADInfo",()=>{
				this.initData();
                this.initParamsData();
                this.adLightBoxData();
                this.mAdLightBoxData();
                this.initunselectData();
			});
        }
    }
</script>
<style>
    #adData{position: absolute;margin-left: 20px;margin-top: 7px;color: #606266;}
    #interview_member h3{margin-left: 15px;}
    #interview_member .heightshow{color: red;font-weight: bold;}
    .el-tag-written-m{ margin-left: 6px; }
    .el-select-room{width: 300px;}
</style>
